import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-agreement',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './user-agreement.component.html',
  styleUrl: './user-agreement.component.scss',
})
export class UserAgreementComponent {}
